






import { Component, Vue } from 'vue-property-decorator';
import RequestInfoOffer from '@/components/RequestOffer/RequestInfoOffer.vue'; // @ is an alias to /src

@Component({
  components: {
    RequestInfoOffer,
  },
})
export default class Offer extends Vue {}
